import React from 'react';

const DEFAULT_STATUS_DATA = [
  { label: 'Mới tiếp nhận', value: 0, color: '#6366F1' },
  { label: 'Đang xử lý', value: 0, color: '#3B82F6' },
  { label: 'Đã hoàn thành', value: 0, color: '#10B981' },
  { label: 'Đóng', value: 0, color: '#EF4444' }
];

export default function StatusHorizontalBarCard({ data = DEFAULT_STATUS_DATA, isLoading = false, timeLabel = '' }) {
  const currentData = Array.isArray(data) && data.length > 0 ? data : DEFAULT_STATUS_DATA;
  const maxVal = Math.max(...currentData.map((d) => Number(d.value) || 0), 1);

  return (
    <div className="bg-white rounded-lg p-4 md:p-5 shadow-xs border border-gray-200 h-full flex flex-col justify-between">
      {/* Header */}
      <h3 className="text-xs md:text-sm font-bold text-gray-800 uppercase tracking-wider mb-3">
        Phản ánh theo trạng thái {timeLabel ? `(${timeLabel})` : ''}
      </h3>

      {/* Progress Bars List */}
      <div className="space-y-3.5 flex-1 flex flex-col justify-center">
        {isLoading ? (
          Array.from({ length: 4 }).map((_, idx) => (
            <div key={idx} className="flex items-center gap-3 animate-pulse">
              <div className="w-24 h-4 bg-gray-200 rounded flex-shrink-0" />
              <div className="flex-1 bg-gray-100 h-4 rounded-md" />
              <span className="w-6 text-right text-xs font-bold text-gray-400 flex-shrink-0">-</span>
            </div>
          ))
        ) : (
          currentData.map((item, idx) => {
            const val = Number(item.value) || 0;
            const pct = maxVal > 0 && val > 0 ? (val / maxVal) * 100 : 0;
            return (
              <div key={idx} className="flex items-center gap-3">
                <span className="w-24 text-xs font-semibold text-gray-600 flex-shrink-0 truncate">
                  {item.label}
                </span>
                <div className="flex-1 bg-gray-100/80 h-4 rounded-md overflow-hidden">
                  <div
                    className="h-full rounded-md transition-all duration-500"
                    style={{
                      width: `${pct}%`,
                      backgroundColor: item.color
                    }}
                  />
                </div>
                <span className="w-6 text-right text-xs font-bold text-gray-800 flex-shrink-0">
                  {val}
                </span>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
